import React, { useState } from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../../components/Checkbox";
import Icon from "../../../../../components/Icon";
import Actions from "../../../../../components/Actions";
import Modal from "../../../../../components/Modal";
import Schedule from "../../../../../components/Schedule";
import Control from "./Control";

const Row = ({ item, value, onChange, onEdit, onDelete, onDuplicate }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [startTime, setStartTime] = useState(new Date());

    const [visibleModalSchedule, setVisibleModalSchedule] = useState(false);

    const actions = [
        {
            title: "Modifier la promotion",
            icon: "edit",
            action: () => onEdit ? onEdit(item) : console.log("Edit promotion"),
        },
        {
            title: "Dupliquer la promotion",
            icon: "copy",
            action: () => onDuplicate ? onDuplicate(item) : console.log("Duplicate promotion"),
        },
        {
            title: "Supprimer la promotion",
            icon: "trash",
            action: () => onDelete ? onDelete(item.id) : console.log("Delete promotion"),
        },
    ];

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <Checkbox
                        className={styles.checkbox}
                        value={value}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                </div>
                <div className={styles.col}>
                    <div
                        className={styles.item}
                        onClick={() => onEdit ? onEdit(item) : null}
                    >
                        <div className={styles.avatar}>
                            <img src="/images/content/promotion_logo.png" alt="Promotion" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.product}>{item.title_promotion || 'Titre non spécifié'}</div>
                            <div className={styles.date}>
                                <Icon name="calendar" size="20" /> {item.training_start_date ? new Date(item.training_start_date).toLocaleDateString() : 'Date non spécifiée'}
                            </div>
                        </div>
                    </div>
                    <Actions
                        className={styles.actions}
                        classActionsHead={styles.actionsHead}
                        items={actions}
                    />
                </div>
                <div className={styles.col}>
                    <div className={styles.contact}>
                        {item.training_start_date ? new Date(item.training_start_date).toLocaleDateString() : '-'}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.contact}>
                        {item.training_end_date ? new Date(item.training_end_date).toLocaleDateString() : '-'}
                    </div>
                </div>
                <div className={styles.col}>
                    {item.date}
                    <Control
                        className={styles.control}
                        item={item}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                </div>
            </div>
            <Modal
                visible={visibleModalSchedule}
                onClose={() => setVisibleModalSchedule(false)}
            >
                <Schedule
                    startDate={startDate}
                    setStartDate={setStartDate}
                    startTime={startTime}
                    setStartTime={setStartTime}
                />
            </Modal>
        </>
    );
};

export default Row;
